import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { Layout } from 'containers';
import { Breadcrumb, FeatherIcon, Loader } from 'components';
import { UsersProvider } from 'providers';

const Users = () => {
    const [ pageLoading, setPageLoading ] = useState(true);
    const [ users, setUsers ] = useState([]);

	useEffect(() => {
		const fetchData = async () => {
            const users = await UsersProvider.getAll();
            setUsers(users.results);
            setPageLoading(false);
		};
		fetchData();
    }, [ setUsers, setPageLoading ]);

    return (
        <Layout>
			{pageLoading && <Loader />}
			<Breadcrumb
                title="Manage Users"
			/>
            <Row className="inbox-wrapper">
                <Col lg={12}>
                    <Card>
                        <CardBody>
                            <Row>
                                <Col lg={12} className="email-content">
                                    <div className="email-inbox-header">
                                        <Row className="row align-items-center">
                                            <Col lg={6}>
                                                <div className="email-title mb-2 mb-md-0">
                                                    <span className="icon">
                                                        <FeatherIcon icon="database" />
                                                    </span> Users <span className="new-messages">(2 new records)</span>
                                                </div>
                                            </Col>
                                            <Col lg={6}>
                                                <div className="email-search">
                                                    <div className="input-group input-search">
                                                        <input className="form-control" type="text" placeholder="Search customers..." />
                                                        <span className="input-group-btn">
                                                            <button className="btn btn-outline-secondary" type="button">
                                                                <FeatherIcon icon="search" />
                                                            </button>
                                                        </span>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
							<div className="table-responsive">
								<table className="table table-hover mb-0">
									<thead>
										<tr>
											<th className="pt-0">#</th>
											<th className="pt-0">First name</th>
											<th className="pt-0">Last name</th>
											<th className="pt-0">Role</th>
											<th className="pt-0">Email</th>
											<th className="pt-0">Username</th>
											<th className="pt-0">Created</th>
                                            {/* <th className="pt-0 text-right">Actions</th> */}
										</tr>
									</thead>
									<tbody>
                                        {users.length > 0 && users.map((item, idx) => (
                                        <tr key={item.id}>
                                            <td>{idx + 1}</td>
                                            <td>{item.first_name}</td>
                                            <td>{item.last_name}</td>
                                            <td>{item.user_role.label}</td>
                                            <td>{item.email}</td>
                                            <td>{item.username}</td>
                                            <td>{moment(item.created).format('DD MMM, YYYY')}</td>
                                            {/* <td className="text-right"></td> */}
                                        </tr>))}
                                        {users.length === 0 &&
                                        <tr><td colSpan={12} className="text-center">No user record available</td></tr>}
                                    </tbody>
                                </table>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Layout>
    );
};

export default Users;
